<template>
  <div class="text-center">
    <v-dialog v-model="dialog" max-width="700" persistent>
      <v-card>
        <v-card-title class="text-h5 orange darken-3 white--text"> Generar nueva factura DGI. </v-card-title>

        <v-card-text class="pt-4">  
            <v-form ref="refFormFactura" >
                <div class="row">
                    <div class="col mb-0 pb-0">
                    <v-text-field v-model.trim="ruc" :disabled="loading" label="Ingresar RUC/Documento/Pasaporte:" filled append-icon="mdi-eye" @input="changeruc" @click:append="buscarruc" hide-details :rules="[v => !!v || 'campo obligatorio']" />
                    </div>
                    <div class="col mb-0 pb-0">
                    <v-text-field v-model.trim="filtros.razon" label="Ingresa la razon social:" filled append-icon="mdi-account" dense hide-details v-show="ruc_data.type" :rules="[v => !!v || 'campo obligatorio']" />
                    </div> 
                </div>

                <div class="row">
                    <div class="col py-0">
                    <p class="my-0 py-0"> nombre: {{ ruc_data.name }} </p>
                    <p class="my-0"> tipo: {{ ruc_data.ruc_type_display }} </p>
                    </div>
                    <div class="col py-0">
                    <p class="my-0 py-0"> receptor: {{ ruc_data.type }} </p>
                    <p class="my-0"> {{ ruc_data.type_display }} </p>
                    </div>
                    <div class="col py-0">
                    <p class="my-0 py-0"> dv: {{ ruc_data.dv }} </p> 
                    </div>
                </div> 

                <div class="row" v-show="ruc_data.type"> 
                    <div class="col-xs-12 col-sm-6 mb-0 pb-0">
                        <v-text-field v-model.number="filtros.monto_total" type="number" label="monto a facturar:" filled append-icon="mdi-account" dense hide-details v-show="ruc_data.type" :rules="[v => !!v || 'campo obligatorio']" />
                    </div> 
                    <div class="col-xs-12 col-sm-6 mb-2 pb-0">
                        <v-text-field v-model.trim="filtros.fecha_pago" type="date" label="fecha del pago:" filled append-icon="mdi-account" dense hide-details v-show="ruc_data.type" :rules="[v => !!v || 'campo obligatorio']" />
                    </div> 
                    <div class="col-xs-12 mb-0 pb-0">
                        <v-text-field v-model.trim="filtros.description" label="Ingresa una descripcion del concepto a facturar:" filled append-icon="mdi-account" dense hide-details v-show="ruc_data.type" :rules="[v => !!v || 'campo obligatorio']" />
                    </div> 
                </div> 
                
                <div class="row" v-show="ruc_data.type"> 
                    <div class="col">
                    <v-select filled :items="getTiposPersonas()" v-model="filtros.tipo_receptor" :disabled="!editar_tipo_receptor" label="tipo receptor:" return-object dense hide-details />  
                    </div>
                    <div class="col">
                    <v-select filled :items="getTipoPagos()" v-model="filtros.tipo_pago" label="forma de pago:" return-object dense hide-details />
                    </div>
                </div> 
                <div class="row" v-show="ruc_data.type" v-if="ruc_sin_dv && filtros.tipo_receptor && (filtros.tipo_receptor.id=='01')"> 
                    <div class="col mt-0 mb-4 py-0"> 
                    <v-text-field v-model.trim="ruc_data.dv" label="Digito verificador DV obligatorio si es Contribuyente:" filled prepend-icon="mdi-key" placeholder="Ingresa el digito verificador del RUC" dense hide-details />
                    </div>
                </div> 
                <div class="row" v-show="ruc_data.type"> 
                    <div class="col mt-0 mb-4 py-0">
                    <v-text-field v-model.trim="filtros.direccion" label="Ingresa la direccion del destinatario: (opcional)" outlined append-icon="mdi-map" dense hide-details />
                    </div>
                </div> 
                <div class="row" v-show="ruc_data.type"> 
                    <div class="col my-0 py-0">
                    <v-text-field v-model.trim="filtros.email" type="email" label="Ingresa el correo del destinatario (para la factura):" filled append-icon="mdi-email" dense hide-details class="pb-0 mb-0" />
                    <v-checkbox v-model="enviar_correo" color="orange" label="Enviar factura al correo" class="py-0 my-0" />
                    </div>
                </div> 

                <div v-if="filtros.tipo_receptor && filtros.tipo_receptor.id == '01'">
                    <p class="mb-1 mt-4 orange--text">Debe seleccionar provincia-distrito-corregimiento para este tipo de RUC:</p>
                    <div class="row">
                        <div class="col">
                            <v-select filled :items="filtros.provincias" v-model="filtros.provincia" label="Provincia" item-text="provincia" @input="selprovincia" return-object dense hide-details />
                        </div>
                        <div class="col">
                            <v-select filled :items="filtros.distritos" v-model="filtros.distrito" label="Distrito" item-text="distrito" @input="seldistrito" return-object dense hide-details />
                        </div>
                        <div class="col">
                            <v-select filled :items="filtros.corregimientos" v-model="filtros.corregimiento" label="Corregimiento" item-text="corregimiento" return-object dense hide-details />
                        </div>
                    </div>
                    <p class="mt-1" v-if="filtros.corregimiento">
                        codigo de ubicacion seleccionada: {{ filtros.corregimiento.codigo }}
                    </p>
                </div>
                <div v-if="filtros.tipo_receptor && filtros.tipo_receptor.id == '04'">
                    <p class="mb-1 mt-4 orange--text">Debe seleccionar el pais del extranjero:</p>
                    <div class="row">
                        <div class="col">
                            <v-select filled :items="paises" v-model="country_extranjero" label="Pais del extranjero" item-text="nombre" return-object dense hide-details />
                        </div>
                    </div>
                </div>
                <p class="text-center mt-8" v-if="msg">  {{ msg }} </p>
            </v-form>

        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="orange" :loading="loading || loading_fact_bk" :disabled="facturado" dark @click="enviar()"> {{ ruc_data.type?'Generar facturar':'Consultar Ruc' }} </v-btn>
          <v-btn color="grey" :loading="loading" outlined tile @click="cerrar()"> Cerrar </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <ver_factura_ispi ref="refver_factura_ispi"/>
  </div>
</template>

<script>
import { send_email } from '@/views/upi/factura_ispi/email';
import { apifacturar, getBackup } from '@/views/upi/factura_ispi/facturafacil';
import { buscar_ruc } from '@/views/upi/factura_ispi/findruc';
import { pronvincias_dgi } from '@/views/upi/factura_ispi/provincias';
import {  getTipoPagos,getTiposPersonas, limpiarObjeto } from '@/views/upi/factura_ispi/utils';
import ver_factura_ispi from '@/views/upi/factura_ispi/ver_factura_ispi.vue';

import {FACTURAS_BASE_PATH} from '@/views/upi/factura_ispi/facturafacil';
import { getdata } from './getdata';
import { todosLosPaises } from './paises';

  export default {
    components:{ver_factura_ispi},
    data() {
      return {
        loading: true,
        dialog: false,
        facturado: false,
        enviar_correo: false,
        editar_tipo_receptor: true,
        loading_fact_bk: false,
        ruc_sin_dv: true,
        ruc: '',
        msg: '',
        ruc_data: {},
        recibo: {},
        estudiante: {},
        programa: {},
        sucursal: {},
        facturar: {},
        getTipoPagos,
        getTiposPersonas,
        country_extranjero: null,
        paises: todosLosPaises,
        filtros:{
          provincia: null,
          distrito: null,
          corregimiento: null,
          email:'',
          direccion:'',
          razon: '',
          header_id: 0,
          description: '',
          fecha_pago: '',
          tipo_pago: getTipoPagos().find(x=>x.id==8),
          tipo_receptor: getTiposPersonas().find(x=>x.id=='02'),

          provincias: [],
          distritos: [],
          corregimientos: [],
        }
      };
    },
    methods: {
      async openmodal() {        
        const rec = {sede_id:82, detalle:[{monto:0}]}
        const progra = {nombre_compuesto:''}

        this.dialog = true;
        this.recibo = rec;
        this.sucursal = {};
        this.estudiante = {}
        this.programa = {}
        this.loading = false
        this.facturado = false
        this.country_extranjero = null
        this.ruc_data = {}
        this.msg = ''
        this.ruc = this.recibo.numero_documento_depositante
        this.filtros.email = this.estudiante.email
        this.filtros.direccion = this.estudiante.domicilio

        this.facturar = getdata(rec, progra)
        this.filtros.provincias = pronvincias_dgi
        this.enviar_correo = !(process.env.VUE_APP_GRAPHQL+'').includes('apidev.')

        const hoy = new Date();
        const año = hoy.getFullYear();
        const mes = String(hoy.getMonth() + 1).padStart(2, '0');
        const dia = String(hoy.getDate()).padStart(2, '0');
        const fechaFormateada = `${año}-${mes}-${dia}`;
        this.filtros.fecha_pago = fechaFormateada
        this.filtros.description = 'Abono a Saldo'

        // // guardarFacturaNulRecibo(47,this.recibo.id)  
        // this.verificarCopiaFactura(rec.id)
      },
      cerrar() {
        this.dialog = false;
      },
      async verificarCopiaFactura(reciboid){
        this.loading_fact_bk = true
        const r = await getBackup(reciboid) 
        this.loading_fact_bk = false
        if(r && r.data && r.data.facturas_vinculadas){
          const res = r.data.facturas_vinculadas;
          if(res.length==0) return
          const recvinc = res[0]
          window.console.log('<><><>', res);
          
          this.$refs.refver_factura_ispi.openmodal(recvinc)
          this.cerrar()
        }
        
      },
      selprovincia(p){
        const prov = this.filtros.provincias.find(x=>x.provincia==p.provincia).distritos
        this.filtros.distritos = prov
        this.filtros.corregimiento = null
        this.filtros.provincia = null
        window.console.log('selprovincia:', prov); 
      },
      seldistrito(p){ 
        window.console.log('seldistrito:', p,this.filtros.distrito); 
        this.filtros.corregimiento = null 
        this.filtros.corregimientos = this.filtros.distrito.corregimientos
      },

      changeruc(){
        this.msg = ''
        this.ruc_data = {}
        this.editar_tipo_receptor = true 
        this.filtros.tipo_receptor = getTiposPersonas().find(x=>x.id=='02')
      },

      async buscarruc(){
        if(!this.ruc){
          this.$root.$notify.show(`Ingrese un RUC.`, {color:'red',x: 'right',});
          return 
        }

        this.loading = true
        this.editar_tipo_receptor = true
        const unidad = this.$store.state.CARGO.sede.unidad_negocio
        const sedeid = this.recibo.sede_id

        const r = await buscar_ruc(this.ruc,unidad, sedeid)
        this.loading = false 
        if(r && r.ruc) { 
          this.ruc_data = r
          this.facturar.document.receptor.name = r.name
          this.facturar.document.receptor.ruc = r.ruc
          this.facturar.document.receptor.dv = r.dv
          this.facturar.document.receptor.ruc_type = r.ruc_type
          this.facturar.document.receptor.type = r.type
          this.filtros.razon = r.name 
          if( r.type == '01' ) {
            this.editar_tipo_receptor = false
            if(r.dv) this.ruc_sin_dv = false
            else this.ruc_sin_dv = true
          }
        }else{
          this.filtros.razon = this.recibo.nombre_depositante 
          this.facturar.document.receptor.ruc = this.ruc
          this.facturar.document.receptor.ruc_type = '1' // natural
          this.facturar.document.receptor.dv = null 
          this.facturar.document.receptor.location = null 
          this.facturar.document.receptor.type = '02'
          this.ruc_data.type = '02'
          this.ruc_sin_dv = true
          this.$root.$notify.show(`RUC no encontrado o invalido`, {color:'red',x: 'right',});
          this.msg = 'RUC no encontrado o invalido, puede continuar con factura de consumidor final NO contibuyente.'
        }  
        const tp = this.facturar.document.receptor.type
        this.filtros.tipo_receptor = getTiposPersonas().find(x=>x.id==tp)
      },
      async enviar() {
        if(!this.ruc_data.type){
          this.buscarruc()
          return
        }

        if( !this.$refs.refFormFactura.validate() ) {
            this.$root.$notify.show(`Complete los campos requeridos.`, {color:'red',x: 'right',});
            return
        }

        if(!this.filtros.corregimiento && this.facturar.document.receptor.type == '01'){
          this.$root.$notify.show(`Seleccione ubicacion del receptor de la factura`, {color:'red',x: 'right',});
          return 
        }

        if(this.filtros.tipo_receptor && (this.filtros.tipo_receptor.id=='01' && !this.ruc_data.dv)){
          this.$root.$notify.show(`Ingresa el DV para este tipo de receptor.`, {color:'red',x: 'right',});
          return 
        }

        if(this.filtros.tipo_receptor.id=='01'){
          this.facturar.document.receptor.dv = this.ruc_data.dv
        }else if(this.filtros.tipo_receptor.id=='02') {
          this.facturar.document.receptor.dv = null 
        }

        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if(!regex.test(this.filtros.email)){
          this.$root.$notify.show(`Ingresa un correo valido`, {color:'red',x: 'right',});
          return
        }

        if(!this.filtros.direccion){
          this.filtros.direccion = '' // blank 
          if( this.facturar.document.receptor.type == '01' ){
            this.$root.$notify.show(`Ingresa la direccion del receptor de la factura, es un contribuyente`, {color:'red',x: 'right',});
            return
          }
        }

        if(this.filtros.tipo_receptor.id == '04' && !this.country_extranjero){
           this.$root.$notify.show(`Debe seleccionar el pais del extranjero`, {color:'red',x: 'right',});
            return
        }

        if(!this.filtros.razon){
          this.$root.$notify.show(`Ingresa la razon social del receptor de la factura`, {color:'red',x: 'right',});
          return 
        }
        if(!this.filtros.monto_total){
          this.$root.$notify.show(`Ingresa el monto a facturar`, {color:'red',x: 'right',});
          return 
        }
        
        if(!this.filtros.tipo_pago){
          this.$root.$notify.show(`Selecciona la forma de pago.`, {color:'red',x: 'right',});
          return 
        }
        if(!this.filtros.tipo_receptor){
          this.$root.$notify.show(`Selecciona el tipo de receptor.`, {color:'red',x: 'right',});
          return 
        }
        if(this.ruc_data.dv) this.facturar.document.receptor.dv = this.ruc_data.dv

        this.facturar.document.payments[0].amount = this.filtros.monto_total
        this.facturar.document.items[0].price = this.filtros.monto_total
        this.facturar.document.items[0].description = this.filtros.description
        this.facturar.header.issue_date = this.filtros.fecha_pago+ 'T00:00:00-05:00'

        if(this.filtros.corregimiento){
          this.facturar.document.receptor.location = this.filtros.corregimiento.codigo
        }
        this.facturar.document.receptor.email = this.filtros.email
        this.facturar.document.receptor.address = this.filtros.direccion
        this.facturar.document.receptor.name = this.filtros.razon
        this.facturar.document.receptor.type = this.filtros.tipo_receptor.id
        this.facturar.document.payments[0].type = this.filtros.tipo_pago.id
        if(this.country_extranjero){
          this.facturar.document.receptor.country = this.country_extranjero.codigo 
        }
        this.msg = ''

        
        let a = 0 
        if(a==0){ 
          this.loading = true
          const limpio = limpiarObjeto(this.facturar)
          const unidad = this.$store.state.CARGO.sede.unidad_negocio
          const sedeid = this.recibo.sede_id

          const r = await apifacturar(limpio,unidad,sedeid)
          this.loading = false
          window.console.log('factura creada::', r);
          if(r && r.pdf_url){
            this.msg = 'facturado, generando el pdf...'
            this.loading = true 

            // guardarFacturaNulRecibo(this, r, this.recibo, this.ruc)
            let pdfurl = r.pdf_url.replaceAll('https://api.facturafacil.com.pa',FACTURAS_BASE_PATH+'/proxy');
            pdfurl = r.pdf_url.replaceAll('https://backend-qa-api.facturafacil.com.pa',FACTURAS_BASE_PATH+'/proxy');

            const response = await fetch(pdfurl);
            if (!response.ok) {
              this.loading = false
              this.msg = 'error al generar el pdf.'
              throw new Error("Error en la descarga");
            }
            const blob = await response.blob();
            const url = URL.createObjectURL(blob);
            const link = document.createElement("a");
            link.href = url;
            link.download = this.filtros.razon+"-factura.pdf";
            document.body.appendChild(link);
            link.click(); 
            link.remove();
            URL.revokeObjectURL(url);
            this.loading = false
            this.facturado = true
            this.msg = ''

            if(this.enviar_correo){
              this.msg = 'enviando factura al correo ...'

              const c = await send_email(this.filtros.email,r.cufe,unidad,sedeid) 
              if(c) this.msg = c.detail 
            }

            this.$emit('fact_dgi_success')

          }else {
            window.console.log('logggg', JSON.stringify(r));
            this.$root.$notify.show(r.message, {color:'red',x: 'right',});            
          }
        }else{
          alert('En desarrollo :)')
        }

      },
    },
  };
</script>
